import { USER_PICKER_ROW_HEIGHT } from '@/components/molecules/person-in-charge/userPickerListRows';

export const userPickerSelectedRowIndex = (
  currentUserId: number | null | undefined,
  users: readonly { readonly id: number }[],
  hasClearOption: boolean,
): number | null => {
  if (currentUserId == null) {
    return null;
  }

  const userIndex = users.findIndex((user) => user.id === currentUserId);
  if (userIndex < 0) {
    return null;
  }

  return userIndex + (hasClearOption ? 1 : 0);
};

export const userPickerScrollOffset = (selectedRowIndex: number | null): number | null => {
  if (selectedRowIndex == null || selectedRowIndex <= 0) {
    return null;
  }

  return selectedRowIndex * USER_PICKER_ROW_HEIGHT;
};

export const userPickerOpenSnapIndex = (
  selectedRowIndex: number | null,
  snapPointCount: number,
): number => {
  if (selectedRowIndex != null && selectedRowIndex > 0 && snapPointCount > 1) {
    return snapPointCount - 1;
  }

  return 0;
};

const USER_PICKER_SHEET_CHROME_HEIGHT = 100;

export const userPickerViewportHeight = (windowHeight: number, snapPoint: string): number => {
  const ratio = Number.parseFloat(snapPoint) / 100;

  return windowHeight * ratio - USER_PICKER_SHEET_CHROME_HEIGHT;
};

export const isUserPickerRowVisible = (rowY: number, viewportHeight: number): boolean =>
  rowY + USER_PICKER_ROW_HEIGHT <= viewportHeight;

export const runUserPickerScrollAttempts = (
  scroll: () => void,
  schedule: (callback: () => void, delayMs: number) => number = setTimeout,
): (() => void) => {
  scroll();
  const timers = [50, 150, 300, 500].map((delayMs) => schedule(scroll, delayMs));

  return () => {
    timers.forEach(clearTimeout);
  };
};
